<template>
  <div class="cardContainerHeader">
    <div class="card filters fvertical" v-if="$root.$data.chores[kindex] ">
      <div @click="setFuture(false)" :class="!isFuture ? 'center-div selected' : 'center-div cs1'">
      <div class="fhr fhr-inbox" style="    --fhr-icon-size: 27px;"></div>
      </div>
      <div @click="setFuture(true)" :class="isFuture ? 'center-div selected' : 'center-div'">
              <div class="fhr fhr-repeat" style="--fhr-icon-size: 27px;"></div>

      </div>
    </div>
    <div v-else></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ChoreContainerHeader",
  props: [
    "isFuture", "kindex"
  ],
  methods: {
    setFuture(val) {
      this.$emit("toggle", val);
    }
  }
}
</script>